import { Dispatch, AnyAction } from 'redux';
import { apiURL } from '../../../config';
import { axiosWithAuth } from '../../../utils/axiosWithAuth';
import { Ticket } from './support.types';

export const TICKETS_LOADING = 'TICKETS_LOADING';
export const GET_TICKET_SUCCESS = 'GET_TICKET_SUCCESS';
export const GET_TICKET_FAILURE = 'GET_TICKET_FAILURE';
export const CREATE_TICKET_SUCCESS = 'CREATE_TICKET_SUCCESS';
export const GET_TICKETS_CSV = 'GET_TICKETS_CSV';
export const CREATE_TICKET_FAILURE = 'CREATE_TICKET_FAILURE';
export const GET_TICKET_ID_SUCCESS = 'GET_TICKET_ID_SUCCESS';
export const GET_TICKET_ID_FAILURE = 'GET_TICKET_ID_FAILURE';
export const COMMENT_SUCCESS = 'COMMENT_SUCCESS';

export const getUserSupportTickets = (userId: string) => async (
  dispatch: Dispatch<AnyAction>
) => {
  dispatch({ type: TICKETS_LOADING });
  try {
    const res = await axiosWithAuth().get(
      `${apiURL}/api/support/tickets/user/${userId}`
    );
    dispatch({ type: GET_TICKET_SUCCESS, payload: res.data });
  } catch (error) {
    dispatch({
      type: GET_TICKET_FAILURE,
      payload: error.response?.data.error,
    });
    return error;
  }
};

export const getAllTickets = () => async (dispatch: Dispatch<AnyAction>) => {
  dispatch({ type: TICKETS_LOADING });
  try {
    const res = await axiosWithAuth().get(`${apiURL}/api/support/all/tickets`);
    dispatch({ type: GET_TICKET_SUCCESS, payload: res.data });
  } catch (error) {
    dispatch({
      type: GET_TICKET_FAILURE,
      payload: error.response?.data.error,
    });
    return error;
  }
};

export const createSupportTicket = (ticket: Ticket) => async (
  dispatch: Dispatch<AnyAction>
) => {
  dispatch({ type: TICKETS_LOADING });
  try {
    const res = await axiosWithAuth().post(
      `${apiURL}/api/support/create-ticket`,
      ticket
    );
    dispatch({ type: CREATE_TICKET_SUCCESS, payload: res.data });
    return res;
  } catch (error) {
    dispatch({
      type: CREATE_TICKET_FAILURE,
      payload: error.response?.data.error,
    });
    return error;
  }
};

export const getSupportTicketById = (id: string) => async (
  dispatch: Dispatch<AnyAction>
) => {
  dispatch({ type: TICKETS_LOADING });
  try {
    const res = await axiosWithAuth().get(
      `${apiURL}/api/support/tickets/${id}`
    );
    dispatch({ type: GET_TICKET_ID_SUCCESS, payload: res.data });
    return res;
  } catch (error) {
    dispatch({
      type: GET_TICKET_ID_FAILURE,
      payload: error.response?.data.error,
    });
    return error;
  }
};

export const commentOnTicket = (
  ticketId: string,
  comment: { comment: string }
) => async (dispatch: Dispatch<AnyAction>) => {
  dispatch({ type: TICKETS_LOADING });
  try {
    const res = await axiosWithAuth().post(
      `${apiURL}/api/support/ticket/${ticketId}/comment`,
      comment
    );
    dispatch({ type: COMMENT_SUCCESS, payload: res.data });
    return res;
  } catch (error) {
    dispatch({
      type: GET_TICKET_ID_FAILURE,
      payload: error.response?.data.error,
    });
    return error;
  }
};

export const getResolvedTicketsCsv = () => async (
  dispatch: Dispatch<AnyAction>
) => {
  // dispatch({ type: TICKETS_LOADING });
  try {
    const res = await axiosWithAuth().get(`${apiURL}/api/support/export`);
    dispatch({ type: GET_TICKETS_CSV });
    return res;
  } catch (error) {
    dispatch({
      type: GET_TICKET_ID_FAILURE,
      payload: error.response?.data.error,
    });
    return error;
  }
};
